var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-date-picker", {
        attrs: {
          color: "purple",
          "min-date": _vm.fromDate(),
          "max-date": _vm.toDate(),
          value: _vm.value,
          "input-props": _vm.attributes,
          masks: _vm.i18n,
          popover: { placement: _vm.$screens({ default: "bottom" }) }
        },
        on: {
          input: function($event) {
            _vm.$emit("input", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.value
        ? _c("holiday-warning", {
            staticStyle: { "max-width": "450px", "text-align": "center" },
            attrs: { day: _vm.value }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ae1838", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ae1838","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/DatePicker/DatePicker.vue
// module id = null
// module chunks = 